import { FC } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import Loading from '../../components/Loading';
import { useHasActiveDidarIntegration } from './DidarAdvancedSettings';
import {
  buildDidarMarketplaceTargetPath,
  buildDidarSettingTargetPath,
} from './didarSettingRoute';

/** /didar-setting[?id=...] → Didar advanced settings, or marketplace if Didar is not added */
const DidarSettingRedirect: FC = () => {
  const [searchParams] = useSearchParams();
  const { hasDidar, loading } = useHasActiveDidarIntegration();

  if (loading) {
    return <Loading />;
  }

  if (!hasDidar) {
    return <Navigate to={buildDidarMarketplaceTargetPath({ showMissingSnackbar: true })} replace />;
  }

  const target = buildDidarSettingTargetPath(`?${searchParams.toString()}`);
  return <Navigate to={target} replace />;
};

export default DidarSettingRedirect;
